import styled from 'styled-components';
import { color, fontFamily } from 'theme';
import { StyledHero } from '../shared/sectionHero/SectionHero.styled';

import { Heading2, Heading3 } from 'components/shared/Typography.styled';
import { StyledContainer as SectionChartContainer } from '../shared/sectionChart/SectionChart.styled';

export const StyledSection = styled.div`
  ${StyledHero} {
    background-color: ${color('indigo_100')};
  }

  ${SectionChartContainer} ${Heading2}::before {
    background-color: ${color('indigo_500')};
  }
`;

export const StyledSubsectionTitle = styled(Heading3)`
  font-family: ${fontFamily('sans')};
`;
